import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';
import * as _ from 'lodash';

@Pipe({
  name: 'formatTruck',
})
export class FormatTruckDetailsPipe implements PipeTransform {
  transform(value: any, ...args) {
    if (args[0] === 'tonsToLbs') {
      if (_.isNumber(value) && value) {
        return _.toString(numeral(value * 2000).format('0,000')) + 'lbs';
      } else {
        return 'N/A';
      }
    } else if (args[0] === 'metersToFeet') {
      if (_.isNumber(value) && value) {
        const start = value * 39.3701;

        const ft = Math.floor(start / 12);
        const inches = start % 12;

        return (
          _.toString(ft) + "' " + _.toString(numeral(inches).format('0a')) + '"'
        );
      } else {
        return 'N/A';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-truck-details/format-truck-details.ts